<template>
  <div class="container" id="requirements">
    <div v-if="scholarship_data">
      <h1>Applicant Requirements</h1>
      <section v-html="scholarship_data.eligibility"></section>
      <div v-if="scholarship_data.active">
        <h3> Applications cannot be submitted after the deadline: {{scholarship_data.active.close}} </h3>
        <router-link :to="{ name: 'apply',
          params: { organization_name: $route.params.organization_name,
            scholarship_name: $route.params.scholarship_name }}">
          <button class="btn btn-primary">Apply Now</button>
        </router-link>
      </div>
      <div v-else>
        <h3>No Active Enrollment Period</h3>
        <div v-if="scholarship_data.closed">
          The enrollment period for this scholarship ended on <strong>{{scholarship_data.closed.close}}</strong>.
        </div>
        <div v-if="scholarship_data.upcoming">
          The next enrollment period for this scholarship begins on <strong>{{scholarship_data.upcoming.open}}</strong>.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../../auth';
export default {
  data(){
    return {
      scholarship_data: null,
      msg: ""
    }
  },
  mounted(){
    if (this.$route.query.notify) {
      this.$toasted.success(this.$route.query.notify,
        {
          position: "bottom-right",
          duration: 10000
        })
    }
    axios.get(`${process.env.VUE_APP_ENDPOINT}/api/${this.$route.params.organization_name}/${this.$route.params.scholarship_name}/`)
      .then(res => {
        this.scholarship_data = res.data
      })
      .catch(err=>{
        this.msg = err
        if( err.response && err.response.status === 404 ){
          this.$router.push({path: "/notFound"})
        }
      })
  }
}
</script>

<style>

</style>
